import { ParsedUrlQuery } from "querystring";

interface BroadcastParams {
  broadcastId: string;
  userId?: string;
  waitlistUserId?: string;
  sourceId: string;
  reportingId: string;
  transactionalType?: "event" | "membership";
}

export const broadcastParamsFromReportingId = (reportingId: string) => {
  const [broadcastId, userId, sourceId, transactionalType] = reportingId.split(
    KeySeparator
  );
  const params: BroadcastParams = {
    broadcastId,
    sourceId,
    reportingId,
    transactionalType: transactionalType as "event" | "membership",
  };

  // A 'w' prefix indicates a waitlist user
  if (userId?.startsWith("w")) {
    params.waitlistUserId = userId.substring(1);
  } else {
    params.userId = userId;
  }

  return params;
};

const KeySeparator = "!";
export const getBroadcastParamsFromQuery = (
  query: ParsedUrlQuery
): BroadcastParams => {
  const reportingId = (query?.["campaign-id"] ?? "") as string;
  return broadcastParamsFromReportingId(reportingId);
};
